import { List } from 'immutable';
import { actions } from './actions';
import * as lib from './lib';

const initialState = new List();

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.ADD:
      return lib.addMessage(state, value);
    case actions.REMOVE:
      return lib.removeMessage(state, value);
    case actions.POP:
      return lib.removeMessage(state);
    case actions.CLEAR:
      return lib.clearMessages(state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/messages/notifications/reducer.js